<div class="px-5 pb-5">
  <h1 class="cbb-page-title mb-4">Configuraciones cemento</h1>
  <app-parametros-cemento-tabla></app-parametros-cemento-tabla>
</div>
